import React from "react";

export const AlertEditSite = () => {
  return (
    <div className="p-6 text-center">
      <div
        className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4"
        role="alert"
      >
        <p className="font-bold">Attention !!</p>
        <p>
          Lors de la suppression d'une entité{" "}
          <strong>
            tous les entités géospatiales attachés vont être supprimer
            difinitivement{" "}
          </strong>
          ainsi que les livrables en correspondances.
        </p>
      </div>
    </div>
  );
};

export const AlerteArborescenceSite = () => {
  return (
    <div
      className="flex items-center p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 "
      role="alert"
    >
      <svg
        className="flex-shrink-0 inline w-4 h-4 mr-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <span className="sr-only">Info</span>
      <div>
        <span className="font-medium">
          Ce site est pas encore stucturé. Ajouter des entités géospatiales
        </span>
      </div>
    </div>
  );
};
